import { isDynamicImportError } from '../lib/isDynamicImportError';

export function AppErrorScreen(input: { error: unknown; reset: () => void }) {
  const isStaleModuleError = isDynamicImportError(input.error);
  const errorMessage = isStaleModuleError
    ? 'The app was updated. Reload to fetch the latest files.'
    : readErrorMessage(input.error);
  const actionLabel = isStaleModuleError ? 'Reload app' : 'Try again';
  const handleAction = isStaleModuleError ? reloadApp : input.reset;

  return (
    <main className="site-content">
      <section className="panel empty-state">
        <h2>Something went wrong.</h2>
        <p>{errorMessage}</p>
        <button onClick={handleAction} type="button">
          {actionLabel}
        </button>
      </section>
    </main>
  );
}

function readErrorMessage(error: unknown) {
  if (error instanceof Error && error.message.length > 0) {
    return error.message;
  }

  return 'Unexpected application error.';
}

function reloadApp() {
  if (typeof window === 'undefined') {
    return;
  }

  window.location.reload();
}
